const logLevels = ["trace", "debug", "info", "warn", "error"];
const Level = Object.fromEntries(logLevels.map((k) => [k, k]));

const cookieUtils = () => window.o_util.cookie;
const debugCookie = "debug";
const patternCookie = "debugPattern";
const levelCookie = "debugLevel";
function writeCookie(namespace, level) {
  cookieUtils().set(debugCookie, "true");
  cookieUtils().set(patternCookie, typeof namespace === "string" ? namespace : namespace.source);
  if (level && level !== "error") {
    cookieUtils().set(levelCookie, level);
  }
}
function removeCookie() {
  [debugCookie, patternCookie, levelCookie].forEach(cookieUtils().remove);
}
function readCookie() {
  const pattern = cookieUtils().get(patternCookie);
  const level = cookieUtils().get(levelCookie);
  return [
    pattern ? new RegExp(pattern) : void 0,
    level && logLevels.includes(level) ? level : "error"
  ];
}

let statusObject;
function updateStatus(pattern, level = "error") {
  statusObject = {
    pattern,
    activated: !!pattern,
    level,
    text: pattern ? "activated" : "deactivated"
  };
  return statusObject;
}
function status() {
  return statusObject || updateStatus(...readCookie());
}

const levelMap = Object.fromEntries(
  logLevels.map((l, i) => [l, [console[l] || console.log, i]])
);
const writeLog = (level, namespace, data) => {
  const st = status();
  const [log, levelIndex] = levelMap[level];
  const [, activeLevelIndex] = levelMap[st.level];
  if (levelIndex < activeLevelIndex || !st.pattern?.test(namespace)) {
    return;
  }
  log(`[ ${level.padStart(5)} ] %c${namespace}:`, "font-weight: bold;", ...data);
};
const noop = () => void 0;

let write = noop;
function logger(namespace) {
  return {
    namespace,
    ...Object.fromEntries(logLevels.map((l) => [l, (...data) => write(l, namespace, data)])),
    log: (level, ...data) => write(level, namespace, data),
    scope: (scope) => logger(`${namespace}.${scope}`)
  };
}
function updateLogger(state) {
  write = state.activated ? writeLog : noop;
  return state;
}
function activate(namespace, level) {
  const ns = namespace || ".*";
  let state = status();
  writeCookie(ns, level);
  state = updateStatus(new RegExp(ns), level);
  return updateLogger(state).text;
}
function deactivate() {
  let state = status();
  removeCookie();
  state = updateStatus(void 0);
  return updateLogger(state).text;
}
function warn(message) {
  if (status().activated) {
    console.warn(message);
  }
}

export { Level, activate, deactivate, logLevels, logger, noop, readCookie, removeCookie, status, updateLogger, updateStatus, warn, writeCookie, writeLog };
/*                              */
